import { Types } from "Shared/Utils";
import { User } from "../Core/oRPC";
import { utcDateTime } from "Shared/Hooks/Time/useTimeZone";

const emptyUser: User = {};

export const MyStore = () => ({
    profile: emptyUser,
    tenant: Types.getUndefined<"Microsoft" | "Torus">(),
    flighting: new Array<string>(),
    userOCERole: "none",
    userOCERoleExpirationTime: utcDateTime().toISO(),
    managers: new Array<string>(),
    managersExpireTime: utcDateTime().toJSDate()
});
